<!-- <span id="{{Id}}">{{displayString}}</span> -->
<ap-timeframe
                [baseId]="Id + '-onset-date'"
                [disabled]="isDisable"
                [visitId]="visitId"
                [patientId]="patientId"
                [(timeframe)]="timeframe"
                (timeframeChanged)="onChange($event)"
                >
        </ap-timeframe>


        <!-- <ap-timeframe
                [baseId]="Id + '-onset-date'"
                [visitId]="visitId"
                [patientId]="patientId"
                [(timeframe)]="timeframe"
                (timeframeChanged)="setOnsetTimeFrame($event)"
                [disabled]="activeProblemItemDto.IsDelete">
        </ap-timeframe> -->